module.exports = __webpack_public_path__ + "staticesp/media/Dt2.f39f7b56.jpg";